const myEnv = 'PRD'; // DEV, PRD

export const myURL = myEnv === 'DEV' ? 'http://localhost:8000/api/' : 'https://crm.miniso.com.mx/api/';

//https://webhook.miniso.com.mx:9088/
//http://crm.miniso.com.mx:8080/

//https://crm.miniso.com.mx/


export const regexPassword =
  /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()-_+=])[A-Za-z\d!@#$%^&*()-_+=]{8,}$/;
export const emailRegex = /^\w+([._-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;